/*
 * ImprintButton.jsx 28.03.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ImprintDialog from './ImprintDialog';

const styles = () => ({
    imprint: {
        bottom: 0,
        right: 0,
        position: 'fixed'
    }
});

/**
 * Button für das Impressum
 */
class ImprintButton extends React.Component {

    render() {

        const { classes, showImprintDialog, imprint_dialog, hideImprintDialog } = this.props;

        return (
            <div>
                <Button color="primary" className={classes.imprint} onClick={showImprintDialog}>Impressum</Button>
                <ImprintDialog open={imprint_dialog.open} hide={hideImprintDialog}/>
            </div>

        );

    }

}

export default withStyles(styles)(ImprintButton);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/imprint/ImprintButton.jsx